import ScheduleRightRail from "../../../../components/Schedule/components/ScheduleRightRail/component";
import { POSITION_MAIN } from "../../../../constants/page";
import logger from "../../../../utils/logger/library";
import ScheduleContainer from "../ScheduleContainer/component";

/**
 * Renders a broadcast schedule widget
 *
 * @param {Object} params the widget params
 * @param {string} position position (main or right)
 *
 * @returns {JSX} component structure for broadcast schedule widget
 */
export function BroadcastScheduleContainer({ params, position }) {
    let scheduleConfig;
    try {
        scheduleConfig = JSON.parse(params?.broadcastschedule?.options || "{}");
    } catch (e) {
        logger.error("(BroadcastScheduleContainer)", e);
        scheduleConfig = {};
    }
    const scheduleProps = {
        type: "sports",
        scheduleConfig,
        ...(params?.title ? { headline: params?.title } : {}),
    };
    if (position === POSITION_MAIN) {
        return <ScheduleContainer params={{ ...params, ...scheduleConfig }} />;
    }
    return (
        <div className="scheduleWrapper">
            <ScheduleRightRail {...scheduleProps} />
        </div>
    );
}
